"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

var _lodash = _interopRequireDefault(require("lodash"));

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _Base = _interopRequireDefault(require("../base/Base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DateTimeComponent =
/*#__PURE__*/
function (_WithLogic) {
  _inherits(DateTimeComponent, _WithLogic);

  _createClass(DateTimeComponent, null, [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _Base.default.schema.apply(_Base.default, [{
        type: 'datetime',
        label: 'Date / Time',
        key: 'dateTime',
        format: 'yyyy-MM-dd hh:mm a',
        useLocaleSettings: false,
        allowInput: true,
        enableDate: true,
        enableTime: true,
        defaultDate: '',
        displayInTimezone: 'viewer',
        timezone: '',
        datepickerMode: 'day',
        datePicker: {
          showWeeks: true,
          startingDay: 0,
          initDate: '',
          minMode: 'day',
          maxMode: 'year',
          yearRows: 4,
          yearColumns: 5,
          minDate: null,
          maxDate: null
        },
        timePicker: {
          hourStep: 1,
          minuteStep: 1,
          showMeridian: true,
          readonlyInput: false,
          mousewheel: true,
          arrowkeys: true
        }
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Date / Time',
        group: 'advanced',
        icon: 'fa fa-calendar-plus-o',
        documentation: 'http://help.form.io/userguide/#datetime',
        weight: 40,
        schema: DateTimeComponent.schema()
      };
    }
  }]);

  function DateTimeComponent(component, options, data) {
    var _this;

    _classCallCheck(this, DateTimeComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateTimeComponent).call(this, component, options, data));
    var timezone = _this.component.timezone || _this.options.timezone;
    var time24hr = !_lodash.default.get(_this.component, 'timePicker.showMeridian', true); // Change the format to map to the settings.

    if (!_this.component.enableDate) {
      _this.component.format = _this.component.format.replace(/yyyy-MM-dd /g, '').replace(/ДД.ММ.ГГГГ /g, '');
    }

    if (!_this.component.enableTime) {
      _this.component.format = _this.component.format.replace(/ hh:mm a$/g, '').replace(/чч:мм a$/g, '');
    } else if (time24hr) {
      _this.component.format = _this.component.format.replace(/hh:mm a$/g, 'HH:mm').replace(/чч:мм a$/g, 'ЧЧ:мм');
    } else {
      _this.component.format = _this.component.format.replace(/HH:mm$/g, 'hh:mm a').replace(/ЧЧ:мм$/g, 'чч:мм a');
    }
    /* eslint-disable camelcase */


    _this.originalComponent.widget = _this.component.widget = {
      type: 'calendar',
      timezone: timezone,
      displayInTimezone: _lodash.default.get(_this.component, 'displayInTimezone', 'viewer'),
      submissionTimezone: _this.submissionTimezone,
      language: _this.options.language,
      useLocaleSettings: _lodash.default.get(_this.component, 'useLocaleSettings', false),
      allowInput: _lodash.default.get(_this.component, 'allowInput', true),
      mode: _this.component.multiple ? 'multiple' : 'single',
      enableTime: _lodash.default.get(_this.component, 'enableTime', true),
      noCalendar: !_lodash.default.get(_this.component, 'enableDate', true),
      format: _this.component.format,
      defaultDate: _this.component.defaultDate,
      hourIncrement: _lodash.default.get(_this.component, 'timePicker.hourStep', 1),
      minuteIncrement: _lodash.default.get(_this.component, 'timePicker.minuteStep', 5),
      time_24hr: time24hr,
      readOnly: _this.options.readOnly,
      minDate: _lodash.default.get(_this.component, 'datePicker.minDate'),
      maxDate: _lodash.default.get(_this.component, 'datePicker.maxDate')
    };
    /* eslint-enable camelcase */
    // Add the validators date.

    _this.validators.push('date');

    _this.pristine = true;
    return _this;
  }

  _createClass(DateTimeComponent, [{
    key: "performInputMapping",
    value: function performInputMapping(input) {
      if (input.widget && this.widget.settings) {
        input.widget.settings.submissionTimezone = this.submissionTimezone;
      }

      return input;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      if (value && value.toString() === 'Invalid Date') {
        return true;
      }

      return _get(_getPrototypeOf(DateTimeComponent.prototype), "isEmpty", this).call(this, value);
    } // This select component can handle multiple items on its own.

  }, {
    key: "createWrapper",
    value: function createWrapper() {
      return false;
    }
  }, {
    key: "trimDateIfNecessary",
    value: function trimDateIfNecessary(dateTimeString) {
      var result = dateTimeString;

      if (result && !this.component.enableTime) {
        result = result.slice(0, 10);
      }

      return result;
    }
  }, {
    key: "getValue",
    value: function getValue(flags) {
      return this.trimDateIfNecessary(_get(_getPrototypeOf(DateTimeComponent.prototype), "getValue", this).call(this, flags));
    }
  }, {
    key: "setValue",
    value: function setValue(value, flags) {
      var newValue = this.trimDateIfNecessary(value);
      return _get(_getPrototypeOf(DateTimeComponent.prototype), "setValue", this).call(this, newValue, flags);
    }
    /**
     * Update a value of this component.
     *
     * @param flags
     * @param value
     */

  }, {
    key: "updateValue",
    value: function updateValue(flags, value) {
      if (!this.hasInput) {
        return false;
      }

      flags = flags || {};
      var newValue = value;

      if (!this.visible && this.component.clearOnHide) {
        newValue = this.dataValue;
      } else if (value === undefined || value === null) {
        newValue = this.getValue(flags);
      }

      var hasDateChanged = this.hasChanged;
      var changed = newValue !== undefined ? hasDateChanged(newValue, this.dataValue) : false; // Валидация включается только если что-то поменялось.

      if (changed) {
        flags.modified = !!changed;
        this.dataValue = newValue;
      }

      if (this.viewOnly) {
        this.updateViewOnlyValue(newValue);
      }

      this.updateOnChange(flags, changed);
      return changed;
    }
  }, {
    key: "emitChange",
    value: function emitChange(flags, changed) {
      if (this.root && !flags.fromRoot) {
        this.root.triggerChange(flags, changed);
      }
    }
  }, {
    key: "redraw",
    value: function redraw() {
      /**
       * Этот метод намеренно оставлен пустым, во избежание
       * ненужных перерисовок. Без этого, компоненты, которые
       * не прошли валидацию, "промаргивали" и теряли свое состояние.
       * Теперь, когда он оставлен пустым, на земле вновь царит мир
       * и порядок...
       * Надолго ли?
       */
    }
  }, {
    key: "onChange",
    value: function onChange(flags, fromRoot) {
      var _this2 = this;

      flags = flags || {};
      flags.fromRoot = !!fromRoot; // flags.modified взят из Base.js.
      // flags.noValidate необходим во избежание переключения флага pristine
      // при инициализации формы, т.к. на setValue срабатывает и onChange.
      // Переключение флага pristine заставляет формио думать, что
      // инпут нужно провалидировать, тогда как при инициализации формы
      // валидировать ничего не нужно. Валидация может быть если пользователь
      // менял что-то или если мы императивно вызываем NestedComponent.checkData
      // aka formApi.validate()

      if (flags.modified && !flags.noValidate) {
        // Add a modified class if this element was manually modified.
        this.pristine = false;
        this.addClass(this.getElement(), 'formio-modified');
      } // Set the changed variable.


      var changed = {
        instance: this,
        component: this.component,
        value: this.dataValue,
        flags: flags
      };

      if (this.component.onChange) {
        this.evaluate(this.component.onChange);
      }

      var checkValidityAndEmitChange = function checkValidityAndEmitChange() {
        flags.modified && !flags.noValidate && _this2.checkValidity(_this2.data, flags.modified);

        _this2.emitChange(flags, changed);
      }; // Emit the change.


      this.emit('componentChange', changed);

      if (this.component.validateOn === 'blur') {
        // this.inputs использовать не представляется возможным т. к. в этот список
        // попадает только "выпадающее меню" календаря. Blur на нем нам не нужен.
        this.element.querySelectorAll('input').forEach(function (elem) {
          elem.removeEventListener('blur', checkValidityAndEmitChange);
          elem.addEventListener('blur', checkValidityAndEmitChange);
        });
      }

      if (this.component.validateOn === 'change') {
        checkValidityAndEmitChange();
      }
    }
  }, {
    key: "blockByUser",
    value: function blockByUser(user) {
      _get(_getPrototypeOf(DateTimeComponent.prototype), "blockByUser", this).call(this, user);

      var input = this.widget.calendar._input;
      input.setAttribute('disabled', 'disabled');
      input.style.borderColor = this.blockedUserColor;
      this.addBlockByWrapper();
      this.widget.suffix.setAttribute('style', 'opacity: 0.2; pointer-events: none;'); // Иконка календаря
    }
  }, {
    key: "unblockByUser",
    value: function unblockByUser() {
      _get(_getPrototypeOf(DateTimeComponent.prototype), "unblockByUser", this).call(this);

      var input = this.widget.calendar._input;
      input.removeAttribute('disabled');
      input.style.removeProperty('border-color');
      this.addBlockByWrapper();
      this.widget.suffix.setAttribute('style', 'cursor: pointer'); // Иконка календаря
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return DateTimeComponent.schema();
    }
  }, {
    key: "emptyValue",
    get: function get() {
      return '';
    }
  }]);

  return DateTimeComponent;
}((0, _WithLogic2.default)(_Base.default));

exports.default = DateTimeComponent;